import React from 'react';

interface BackgroundImageProps {
  src: string;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({ 
  src, 
  className = '', 
  children,
  style = {}
}) => {
  // Convert PNG to WebP for better compression if supported
  const getWebPSource = (originalSrc: string) => {
    if (originalSrc.includes('lovable-uploads') && originalSrc.endsWith('.png')) {
      return originalSrc.replace('.png', '.webp');
    }
    return originalSrc;
  };

  const webpSrc = getWebPSource(src);
  
  return (
    <div 
      className={className}
      style={{
        ...style,
        backgroundImage: `url("${webpSrc}"), url("${src}")`,
        backgroundSize: style.backgroundSize || 'cover',
        backgroundPosition: style.backgroundPosition || 'center',
        backgroundRepeat: style.backgroundRepeat || 'no-repeat'
      }}
    >
      {children}
    </div>
  );
};

export default BackgroundImage;